import Modal from './modal.js';
import { getParameterByName } from '../../base/utils.js';
import { ResizeHandler, isMobileWidth } from '../../base/dom-utils.js';
import Analytics from '../../base/wyn-analytics-module.js';

class ExtendedHeroVideoSlide {
  constructor() {
    this.onOpenVideoModal();
  }
  initVideos(videos) {
    if (videos) {
      if (!isMobileWidth()) {
        $.each(videos, (i, el) => {
          this.createVideos(i, el);
        });
        $(videos[0]).closest('.extended-hero-container')
          .addClass('videos-loaded');
      }
      // On Resize- check if videos have been loaded if not mobile
      ResizeHandler.addResizeEndFn(() => {
        if (!isMobileWidth() && !($('.extended-hero-container').hasClass('videos-loaded'))) {
          $.each(videos, (i, el) => {
            this.createVideos(i, el);
          });
        }
      });
    }
  }
  createVideos(i, el) {
    if ($(el).hasClass('slick-cloned')) {
      $(el).find('.background-video')
        .attr('id', 'clone' + i);
    }
    this.setupVideo(i, $(el).find('.background-video'), $(el));
  }
  analyticCall(id, typeOfEvent) {
    const playlistItem = jwplayer(id).getPlaylistItem().sources[0];
    let videoName = playlistItem.file,
      videoType = playlistItem.type;
    const segments = videoName.split('/');
    const lastSegment = segments.pop();
    if (lastSegment) {
      videoName = lastSegment;
    }
    window.AdobeWebSdk && window.AdobeWebSdk.videoMilestoneTracking(typeOfEvent, videoName, videoType);
  }
  setupVideo(i, el, container) {
    let id = $(el).attr('id');

    if (id) {
      const milestones = {
        '25%': false,
        '50%': false,
        '75%': false,
        '100%': false
      };
      let videoStarted = false;
      let player = jwplayer(id).setup({
        file: $(el).data('video-file'),
        playlist: $(el).data('video-playlist'),
        autostart: $(el).data('video-autostart'),
        controls: $(el).data('video-controls'),
        mute: $(el).data('video-mute'),
        repeat: $(el).data('video-loop'),
        stretching: $(el).data('video-stretching') || 'fill',
        height: $(el).data('video-height') || '100%',
        width: $(el).data('video-width') || '100%',
        displaydescription: false,
        displaytitle: false,
        preload: 'auto',
        autoPause: {
          viewability: true,
          pauseAds: true
        }
      })
        .on('ready', () => {
        // loop attr causes complete event don't fire
          $(player.getContainer()).find('video')
            .removeAttr('loop');

          if ((player.getConfig().autostart) && ($(container).hasClass('slick-active'))) {
          // Direct call, autoplay isn't detected
            Analytics.satelliteTracker('jwplay');
          }

          $(player.getContainer()).find('.jw-media')
            .css({
              'background-image': 'url("' + $(el).data('video-poster') + '")',
              'background-size': 'cover'});
        })
        .on('complete', () => {
          // Analytics flags
          setTimeout(() => {
            $(player.getContainer()).find('video')
              .attr('data-is-complete', true);
          }, 1);

          // Manually loop
          if (typeof loop !== typeof undefined) {
            this.playVideo(id);
          }
        })
        .on('firstFrame', () => {
        // Analytics flag
          $(player.getContainer()).find('video')
            .attr('data-is-started', true);
          if (!videoStarted) {
            this.analyticCall(id, 'videoStart');
            videoStarted = true;
          }
        })
        .on('play', () => {
          if (id.indexOf('clone') === -1) {
            this.analyticsMetaData(id);
          }
        })
        .on('time', (event) => {
          const percentagePlayed = (event.position / event.duration) * 100;

          if (percentagePlayed >= 25 && !milestones['25%']) {
            milestones['25%'] = true;
            this.analyticCall(id, 'video25');
          }

          if (percentagePlayed >= 50 && !milestones['50%']) {
            milestones['50%'] = true;
            this.analyticCall(id, 'video50');
          }

          if (percentagePlayed >= 75 && !milestones['75%']) {
            milestones['75%'] = true;
            this.analyticCall(id, 'video75');
          }

          // within 1 second of end
          if ((event.duration - event.position <= 1) && !milestones['100%']) {
            milestones['100%'] = true;
            this.analyticCall(id, 'video100');
          }
        });
    }
  }

  analyticsMetaData(id) {
    const playlistItem = jwplayer(id).getPlaylistItem().sources[0];
    let name = playlistItem.file,
      type = playlistItem.type;
    name = name.split('\\').pop()
      .split('/')
      .pop()
      .split('-')
      .shift();

    // Analytics data
    window.digitalData.rewards = {
      activity: {
        videoName: name,
        videoType: type
      }
    };
  }
  onOpenVideoModal() {
    $(document).on('click', 'a[href*="#openVideoModal"]', (e) => {
      e.preventDefault();
      let url = getParameterByName('url', $(e.currentTarget).attr('href'));
      if (url) {
        let $video = `<div id="videoModal" data-video-file="${url}"></div>`;
        Modal.populateModalContent($video);
        Modal.show();
        this.setupVideo(1, $('#videoModal'));
      }
    });
  }
}

export default new ExtendedHeroVideoSlide();
